export const REQUEST_LEGAL_DECLARATION =
  'src/LegalDeclarationModal/REQUEST_LEGAL_DECLARATION'
export const REQUEST_LEGAL_DECLARATION_SUCCESS =
  'src/LegalDeclarationModal/REQUEST_LEGAL_DECLARATION_SUCCESS'
export const REQUEST_LEGAL_DECLARATION_FAILURE =
  'src/LegalDeclarationModal/REQUEST_LEGAL_DECLARATION_FAILURE'

export const REQUEST_LEGAL_DECLRATION_REL = 'GetAllQuoteDeclarations'
